//Styles
import './loader.scss';

export interface LoaderProps {
    isLoading?: boolean;
    loadingText?: string;
    type?: LoaderTypes;
}

export enum LoaderTypes {
    Big = "big",
    Small = "small"
}

const Loader = (props: LoaderProps) => {
    return (
        <div className="loader-wrapper">
            {props.isLoading ?
                <div className={`loader_${props.type}`}>
                    <div className="loading">
                        {props.loadingText?.split("").map((char, index) => {
                            return (
                                <span key={index}>{char === "-" ? <span>&nbsp;</span> : char}</span>
                            )
                        })}
                    </div>
                </div> : null
            }
        </div>
    )
}


export default Loader;